import { render, staticRenderFns } from "./AdminIncoTermCodes.vue?vue&type=template&id=62b6696a&scoped=true&"
import script from "./AdminIncoTermCodes.vue?vue&type=script&lang=js&"
export * from "./AdminIncoTermCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6696a",
  null
  
)

export default component.exports